import { Outlet } from "react-router-dom";
import AdminHeader from "../components/AdminHeader";
import Footer from "../components/Footer";
import TopMenuStrip from "../components/TopMenuStrip";

const AdminLayout = () => {
  return (
    <>
      <AdminHeader />
      <section className="asset-content">
      
        <div className="row" style={{marginBottom:'10px'}}>
          <TopMenuStrip />
        </div>
      
        <div className="minHeightDiv">
        <Outlet />
      </div>
      
      </section>

      <Footer />
    </>
  );
};

export default AdminLayout;
